import * as ContactUsContactUsPageUploads from "$lib/data/generated/uploads/contact us/ContactUsPage/uploads.js";
import * as ContactUsFeatures01Uploads from "$lib/data/generated/uploads/contact us/Features 01/uploads.js";
import * as ContactUsFeaturesContactUsUploads from "$lib/data/generated/uploads/contact us/Features Contact Us/uploads.js";
import * as ContactUsFeaturesForPageLocationServicesUploads from "$lib/data/generated/uploads/contact us/Features For Page Location Services/uploads.js";
import * as ContactUsFormContactUsUploads from "$lib/data/generated/uploads/contact us/Form Contact Us/uploads.js";
import * as ContactUsFormSubmission01Uploads from "$lib/data/generated/uploads/contact us/FormSubmission 01/uploads.js";
import * as ContactUsPageBannerUploads from "$lib/data/generated/uploads/contact us/PageBanner/uploads.js";
import * as ContactUsSideBySideUploads from "$lib/data/generated/uploads/contact us/SideBySide/uploads.js";

export const uploads = {
  ...ContactUsContactUsPageUploads.uploads,
  ...ContactUsFeatures01Uploads.uploads,
  ...ContactUsFeaturesContactUsUploads.uploads,
  ...ContactUsFeaturesForPageLocationServicesUploads.uploads,
  ...ContactUsFormContactUsUploads.uploads,
  ...ContactUsFormSubmission01Uploads.uploads,
  ...ContactUsPageBannerUploads.uploads,
  ...ContactUsSideBySideUploads.uploads
};
